import { Button, Menu, MenuItem, Modal, Typography } from "@mui/material";
import { Box, useMediaQuery } from "@mui/system";
import React, { useEffect, useState } from "react";
import styles from "./laymanmain.module.css";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LymanMainComps from "./components/LymanMainComps";
import Router from "next/router";
import Head from "next/head";
import Image from "next/image";

import { useRouter } from "next/router";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

const chaptersMetaData = {
  default: {
    title: "School Layman Explanation | School of Our Divine Infinite Being",
    description:
      "Explore the Layman Explanation at the School of Our Divine Infinite Being. Delve into our unique blend of polytheism and monism through our detailed symbolic Archetypes and Theurgic practices.",
    keywords:
      "Divine Theurgy, Polytheistic Monism, Oracle, Symbolic Archetypes, Theurgy, Divine Infinite Being, Self Realization",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation",
  },
  1: {
    title:
      "ROTA, The Wheel of Astrological Tarot | School of Our Divine Infinite Being",
    description:
      "Explore the deep symbolism, history, and esoteric traditions behind the ROTA — the Wheel of Astrological Tarot. Discover how astrology, psychology, and mysticism merge with the rich heritage of the Golden Dawn, Rosicrucianism, and Aleister Crowley in the Divine Arcana taught at the School of Our Divine Infinite Being.",
    keywords:
      "ROTA, Astrological Tarot, Rota Tarot, Divine Arcana, Mystery School, Astrology, Jungian Archetypes, Platonic Kabbalah, Rosicrucianism, Freemasonry, Eliphas Lévi, Golden Dawn, Aleister Crowley, Thoth Tarot, Tarot History, Western Esotericism, Divine Theurgy, Esoteric Tarot, Zodiac, Planets, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=1",
  },
  2: {
    title: "The Orphic Egg | School of Our Divine Infinite Being",
    description:
      "Explore the profound symbolism of the Orphic Egg, a sacred cipher in the Western Mystery tradition. Discover its connection to Orpheus, Phanes, and the Divine Arcana Tarot at the School of Our Divine Infinite Being.",
    keywords:
      "Orphic Egg, Orphism, Phanes, Cosmic Egg, Divine Arcana, Western Mystery Tradition, Thoth Tarot, Pythagorean, Kundalini, Divine Theurgy",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=2",
  },
  3: {
    title:
      "The Transpersonal Egg and Psychosynthesis | School of Our Divine Infinite Being",
    description:
      "Discover the Transpersonal Egg, the culmination of Jungian integration and Psychosynthesis at our school. Explore the map of consciousness, from the Higher Self to the Lower Unconscious, and its role in spiritual growth.",
    keywords:
      "Transpersonal Egg, Psychosynthesis, Jungian Integration, Roberto Assagioli, Transpersonal Self, Higher Self, Lower Unconscious, Archetypes, Individuation, Esoteric Psychology, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=3",
  },
  4: {
    title:
      "The Pentagram: Sacred Geometry and Theurgy | School of Our Divine Infinite Being",
    description:
      "Uncover the esoteric meaning of the Pentagram, from Pythagorean sacred geometry to its role as a theurgic tool for balancing the five elements. Explore its connection to divine emanation and archetypal forces at our school.",
    keywords:
      "Pentagram, Sacred Geometry, Pythagoreanism, Theurgy, Divine Emanation, Five Elements, Quintessence, Archetype of Mars, Iamblichus, Pythagoras, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=4",
  },
  5: {
    title:
      "Yin and Yang: A Universal Dance of Opposites | School of Our Divine Infinite Being",
    description:
      "Explore the profound concept of Yin and Yang, the universal dance of opposites. Learn how this principle of interdependent duality and harmony is integrated with Western dialectical monism at our school.",
    keywords:
      "Yin and Yang, Taijitu, Taoism, Duality, Balance, Harmony, Chinese Philosophy, Dialectical Monism, Qi, Wu Wei, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=5",
  },
  6: {
    title:
      "String Theory, Quantum Mechanics and the Cosmic Mandala | School of Our Divine Infinite Being",
    description:
      "Explore the intersection of String Theory, Quantum Mechanics, and the Cosmic Mandala. Discover how our school integrates modern physics with Jungian psychology and theurgical practice to understand the nature of the Self and the cosmos.",
    keywords:
      "String Theory, Quantum Mechanics, Cosmic Mandala, Holographic Principle, Jungian Psychology, Theurgy, Psyche-Singularity, Archetype, Self, Ascent, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=6",
  },
  7: {
    title:
      "OM: The Primordial Sound, Theurgy and Kundalini | School of Our Divine Infinite Being",
    description:
      "Explore the profound meaning of OM (AUM), the primordial sound of the universe. Learn its role in theurgy, Kundalini activation, and aligning the chakras for spiritual transformation at our school.",
    keywords:
      "OM, AUM, Primordial Sound, Theurgy, Kundalini, Chakras, Mantra, Pranayama, Meditation, Sacred Syllable, Divine Resonance, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=7",
  },
  8: {
    title:
      "YHVH–Elohim: Sacred Marriage and Cosmic Union of Opposites | Divine Infinite Being",
    description:
      "Discover YHVH–Elohim, the theurgic principle of sacred marriage where center and circumference, masculine and feminine unite. Explore its role in Macrocosmic Union, Theurgy, and the harmony of cosmic polarity.",
    keywords:
      "YHVH-Elohim, Sacred Marriage, Cosmic Union, Macrocosmic Polarity, Theurgy, Divine Syzygy, Alchemical Union, Masculine Feminine Harmony, Sacred Polarity, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=8",
  },
  9: {
    title:
      "Helios: The Solar Logos and Awakening the Luminous Body | Divine Infinite Being",
    description:
      "Discover Helios as the Solar Logos, the divine clarity that illuminates the Self. Learn the theurgy of awakening the luminous body and connecting to the higher self, or Daemon.",
    keywords:
      "Helios, Solar Logos, Luminous Body, Theurgy, Awakening the Light Body, Divine Clarity, Radiant Self, Higher Self, Daemon, Protogonos, Solar Intelligence, Biophotonic Intelligence",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=9",
  },

  "9_helios_part": {
    title: "Helios: The Solar Logos And Witness of All Things | School of Our Divine Infinite Being",
    description: "Discover the doctrine of Helios as the Solar Logos and Witness of All Things. Learn how this solar intelligence functions as the archetype of the radiant Self and a beacon of divine clarity in theurgic practice.",
    keywords: "Helios, Solar Logos, Light Body, Witness of All Things, Solar Intelligence, Radiant Self, Theurgy, Divine Clarity, Divine Infinite Being",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=9_helios_part",
  },

  "9_protogonos_part": {
    title:
      "Protogonos (Phanes): Radiant Firstborn and Total Objective Self | Divine Infinite Being",
    description:
      "Unveil the Orphic mystery of Protogonos (Phanes), the radiant and androgynous Firstborn. Explore how this Divine Double embodies cosmic emergence and is invoked in theurgy to awaken the gods within.",
    keywords:
      "Protogonos, Phanes, Radiant Firstborn, Orphic Egg, Divine Double, Androgynous Archetype, Orphic Mysteries, Cosmic Emergence, Total Objective Self, Theurgy, Awakening the Gods Within, Divine Infinite Being",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=9_protogonos_part",
  },
  10: {
    title:
      "Rādhā–Kṛṣṇa: Infinite Play and Sacred Surrender | Divine Infinite Being",
    description:
      "Explore Rādhā–Kṛṣṇa as emblems of divine play and surrender. Learn how their archetype of openness, longing, and playful invitation softens the soul for theurgic transformation and intimacy with the Divine.",
    keywords:
      "Radha-Krishna, Rādhā, Kṛṣṇa, Divine Play, Sacred Surrender, Bhakti, Archetype of Love, Soul’s Yielding, Theurgy, Divine Lovers, Peacock Feather, Flute of Krishna, Spiritual Intimacy, Innocence in Praxis",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=10",
  },
  "10_kalikrishna": {
    title:
      "Rādhā–Kṛṣṇa: Infinite Play and Sacred Surrender | School of Our Divine Infinite Being",
    description:
      "Discover the mystery of Rādhā–Kṛṣṇa as the archetype of divine play and surrender. Learn how their love, innocence, and intimacy prepare the soul for theurgic initiation and transformation.",
    keywords:
      "Radha-Krishna, Rādhā, Kṛṣṇa, Divine Play, Sacred Surrender, Bhakti, Theurgy, Divine Lovers, Archetype of Love, Spiritual Intimacy, Soul’s Yielding, Peacock Feather, Flute of Krishna, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=10_kalikrishna",
  },
  11: {
    title:
      "Kālī: The Fertile Void and Mother of Mysteries | Divine Infinite Being",
    description:
      "Encounter Kālī not merely as destroyer, but as the fertile void—the infinite womb of renewal. Explore her role as radical unbinding, ecstatic dissolution, and primordial matrix in theurgic initiation.",
    keywords:
      "Kali, Kālī, Fertile Void, Mother of Mysteries, Goddess of Time, Womb of Brahman, Ecstatic Dissolution, Void and Garden, Theurgy, Ego-Death, Sacred Rebirth, Ein Sof, Nuit, Shekhinah, Archetype of Transformation",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=11",
  },
  12: {
    title:
      "Hekátē–Kālī: Threshold Guardians and Purifiers of the Daemonic Crossing | Divine Infinite Being",
    description:
      "Explore the Dark Syzygy of Hekátē and Kālī as guardians of the soul’s crossroads. Learn how these twin forces guide initiation through alignment, purification, and daemonic passage in theurgic practice.",
    keywords:
      "Hekate, Kali, Hekate-Kali, Daemonic Crossing, Dark Syzygy, Threshold Guardians, Theurgy, Soul Initiation, Divine Infinite Being, Anima Mundi, Liberation by Annihilation, Ritual Purification, Daemonic Realm",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=12",
  },
  13: {
    title:
      "Śiva–Śakti: The Living Pulse of Stillness and Becoming | School of Our Divine Infinite Being",
    description:
      "Discover Śiva–Śakti, the primal polarity of witness and pulse, stillness and becoming. Learn how their union grounds all transformation, from genesis to revelation, through the fivefold current of Śakti in our theurgic path.",
    keywords:
      "Śiva-Śakti, Shiva-Shakti, Śiva, Śakti, Consciousness and Power, Divine Polarity, Stillness and Motion, Fivefold Śakti, Sṛṣṭi, Sthiti, Saṃhāra, Tirobhāva, Anugraha, Tantric Cosmology, Axis and Circumference, Witness and Pulse, Kundalini, Theurgy, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=13",
  },
  14: {
    title:
      "Krishna: The Supreme Persona and Infinite Father in Play | School of Our Divine Infinite Being",
    description:
      "Explore Krishna as the ontic Supreme Persona, the Infinite Father revealed in intimacy and play. Discover his role as Beloved, archetype of divine relationality, and assurance that the cosmos is grounded in joy, music, and love.",
    keywords:
      "Krishna, Supreme Persona, Infinite Father, Divine Play, Lila, Beloved, Archetype of Love, Ontic Godhead, Megaverse, Divine Relationality, Cosmic Joy, Flute Symbolism, Transcendent Love, School of Our Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=14",
  },
  15: {
    title:
      "Hermes: Lord of Divination and Overseer of the Rites | School of Our Divine Infinite Being",
    description:
      "Discover Hermes, the god of divination and overseer of the rites. Learn how he governs astrology, Tarot, dreams, and sacred symbols—ensuring every ritual act carries true meaning and returns faithfully to the Infinite.",
    keywords:
      "Hermes, God of Divination, Overseer of the Rites, Astrology, Tarot, Sacred Symbols, Divination, Prophecy, Ritual Praxis, Numerology, Dream Interpretation, Sacred Language, Theurgy, Divine Messenger, Symbolic Order, School of Our Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=15",
  },
  16: {
    title:
      "Aion: Future as Return and The Zodiacal Gate Beyond Chronos | School of Our Divine Infinite Being",
    description:
      "Discover Aion, god of eternal time—the still axis beyond Chronos. Explore how the Zodiacal gates open the crossing into eternity, where each sign becomes a portal from succession to recurrence, guiding prophecy, theurgy, and divine timing.",
    keywords:
      "Aion, Chronos, Eternal Time, Zodiac Gates, Great Year, Kairos, Astrology, Zodiac Signs, Aries, Taurus, Gemini, Cancer, Leo, Virgo, Libra, Scorpio, Sagittarius, Capricorn, Aquarius, Pisces, Theurgy, Prophecy, Block Universe, Divine Timing, School of Our Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=16",
  },

  "16_radhakrishna_innocence": {
    title: "Aion: Eternal Time and the Zodiacal Gate Beyond Chronos | School of Our Divine Infinite Being",
    description: "Explore Aion, the god of eternal time, who reveals the pattern beyond Chronos. Discover how the Zodiacal gates open the crossing into timeless recurrence, divination, and theurgy of divine timing.",
    keywords: "Aion, Chronos, Eternal Time, Zodiac, Zodiacal Gates, Great Year, Block Universe, Theurgy, Divine Timing, Kairos, Astrology, Eternity, Prophecy, Multiverse, School of Our Divine Infinite Being",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=16_radhakrishna_innocence",
  },
  17: {
    title:
      "El Shaddai: The Horned Father and the Sacred Wilderness | School of Our Divine Infinite Being",
    description:
      "Explore El Shaddai as the ancient God of the wilderness and the Horned Father of the Infinite. Discover His role as both wild fertility and sacred order, the primal lawgiver who integrates chaos into divine rhythm.",
    keywords:
      "El Shaddai, Horned God, Wild Father, Wilderness, Hebrew God, Pan, Sacred Order, Fertility, Chaos and Order, Kabbalah, Yesod, Shomer Daltot Yisrael, Wilderness Mysticism, Theurgy, Ancient God, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=17",
  },
  18: {
    title:
      "Illuminating the Shadows: The Veneration of the Full Moon in Ancient Witchcraft | School of Our Divine Infinite Being",
    description:
      "Discover the mystical power of the full moon in ancient witchcraft. Explore Thessalian witches, lunar goddesses, and astrological cycles that awaken psychic abilities, divination, and the Imaginal realm of the soul.",
    keywords:
      "Full Moon, Witchcraft, Thessalian Witches, Lunar Veneration, Hecate, Demeter, Drawing Down the Moon, Psychic Abilities, Divination, Astrology, Lunar Cycles, Zodiac Signs, Lunar Mansions, Lunar Nodes, Retrograde Planets, Eclipses, Sabian Symbols, Ancient Mysticism, Theurgy, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=18",
  },
  "18_elohim": {
    title: "Illuminating the Shadows: The Veneration of the Full Moon in Ancient Witchcraft | School of Our Divine Infinite Being",
    description: "Discover the mystical power of the full moon in ancient witchcraft. Learn how Thessalian witches, lunar goddesses, and astrological cycles awaken psychic abilities, divination, and the soul’s Imaginal realm.",
    keywords: "Full Moon, Witchcraft, Thessalian Witches, Lunar Veneration, Hecate, Demeter, Drawing Down the Moon, Lunar Energies, Psychic Abilities, Divination, Astrology, Zodiac Signs, Lunar Cycles, Lunar Nodes, Lunar Mansions, Retrograde Planets, Eclipses, Sabian Symbols, Ancient Mysticism, Divine Infinite Being",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=18_elohim",
  },

  "18_yhvh": {
    title: "Illuminating the Shadows: The Veneration of the Full Moon in Ancient Witchcraft | School of Our Divine Infinite Being",
    description: "Explore the mystical power of the full moon in ancient witchcraft. Learn how Thessalian witches, lunar goddesses, and astrological cycles shape psychic awakening, divination, and the dance of light and shadow.",
    keywords: "Full Moon, Witchcraft, Thessalian Witches, Lunar Veneration, Hecate, Demeter, Psychic Abilities, Divination, Drawing Down the Moon, Astrology, Zodiac Signs, Lunar Cycles, Lunar Mansions, Lunar Nodes, Retrograde Planets, Sabian Symbols, Theurgy, Divine Infinite Being",
    ogImage: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=18_yhvh",
  },
  19: {
    title:
      "Embracing Darkness: The New Moon’s Journey into the Underworld | Divine Infinite Being",
    description:
      "Discover the spiritual power of the New Moon as a descent into the underworld of the psyche. Guided by Nyx and Hecate, explore shadow work, primal instincts, and Tarot wisdom of The Moon in our theurgical path.",
    keywords:
      "New Moon, Lunar Cycle, Shadow Work, Nyx, Hecate, Underworld, Primal Shadow Self, Tarot The Moon, Astrology, Sun-Moon Conjunction, Zodiac, Lunar Mansions, Lunar Nodes, Theurgy, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=19",
  },
  20: {
    title:
      "The Zodiac and the Planetary Powers | School of Our Divine Infinite Being",
    description:
      "Explore the zodiac signs and planetary gods as radiant vessels of divine intelligences. Discover their Tarot correspondences and spiritual meanings in our theurgical teachings.",
    keywords:
      "Zodiac, Astrology, Planets, Tarot, Theurgy, Aries, Taurus, Gemini, Cancer, Leo, Virgo, Libra, Scorpio, Sagittarius, Capricorn, Aquarius, Pisces, Sun, Moon, Mercury, Venus, Mars, Jupiter, Saturn, Uranus, Neptune, Pluto, Divine Infinite Being",
    ogImage:
      "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
    url: "https://www.divineinfinitebeing.com/layman-explanation?section=20",
  },

  // 21: {
  //   title:
  //     "Ehyeh ('Ehye 'ăšer 'Ehye): The Nondual Infinite Being | Divine Infinite Being",
  //   description:
  //     "Explore Ehyeh ('Ehye 'ăšer 'Ehye), the declaration of nondual being. Understand 'I Am That I Am' as the primordial awareness that is the source and conclusion of all theurgic ritual.",
  //   keywords:
  //     "Ehyeh, 'Ehye 'ăšer 'Ehye, I Am That I Am, Nondual Being, Unconditioned Awareness, Primordial Awareness, Theurgy, Brahman, Atman, Kabbalah, Mysticism, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=21",
  // },
  // 22: {
  //   title:
  //     "YHVH (Yod-Heh-Vav-Heh): The Divine Center & Masculine Principle | Divine Infinite Being",
  //   description:
  //     "Delve into the meaning of YHVH, the sacred axis of being. Understand the four letters (Yod-Heh-Vav-Heh) as a blueprint for aligning with the Divine Center and the unmoved mover.",
  //   keywords:
  //     "YHVH, Yod-Heh-Vav-Heh, Tetragrammaton, Divine Center, Eternal Masculine Principle, Theurgy, Kabbalah, Unmoved Mover, Sacred Axis, Yod, Heh, Vav, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=22",
  // },
  // 23: {
  //   title:
  //     "ELOHIM: The Infinite Horizon & Divine Feminine Principle | Divine Infinite Being",
  //   description:
  //     "Discover ELOHIM as the Divine Feminine Principle, the infinite horizon and cosmic womb. Learn to merge with this fertile void, the counterpart to YHVH, in our theurgic practice.",
  //   keywords:
  //     "Elohim, Infinite Horizon, Eternal Feminine Principle, Divine Womb, Theurgy, Shekinah, Ayin, Cosmic Horizon, Divine Mind, Kabbalah, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=23",
  // },
  // 24: {
  //   title:
  //     "Radha Krishna: The Divine Union of Love & Devotion | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the sacred romance of Radha and Krishna, the ultimate expression of divine love and devotion (Bhakti). Discover how their union symbolizes the soul's journey to merge with the Divine Infinite Being in our school's teachings.",
  //   keywords:
  //     "Radha Krishna, Divine Lovers, Bhakti Yoga, Divine Union, Supreme Love, Sacred Romance, Leela, Divine Play, Purusha and Prakriti, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=24",
  // },
  // 24: {
  //   title:
  //     "Veneration of the Full Moon: Lunar Energies & Witchcraft | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the ancient practice of venerating the Full Moon. Learn how to harness lunar energies for psychic receptivity, transformation, and witchcraft in our school's detailed astrological and mythological guide.",
  //   keywords:
  //     "Full Moon, Veneration, Lunar Energies, Witchcraft, Full Moon Rituals, Psychic Receptivity, Astrology, Lunar Phases, Hecate, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=24",
  // },
  // 25: {
  //   title:
  //     "Veneration of the New Moon: Embracing Darkness & Shadow Self | School of Our Divine Infinite Being",
  //   description:
  //     "Journey into the underworld with the New Moon. Learn to embrace darkness, connect with your primal shadow self, and utilize the potent energies of Hecate and Nyx in your rituals at our school.",
  //   keywords:
  //     "New Moon, Veneration, New Moon Rituals, Shadow Self, Hecate, Nyx, Underworld Journey, Astrology, Tarot, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=25",
  // },
  // 26: {
  //   title:
  //     "Forces of the Sun: Solar Consciousness & Theurgy | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the occult Forces of the Sun and the nature of Solar Consciousness. Learn how our school integrates the solar pulse with theurgy, astrology, and the concept of the Emerging Spirit for spiritual awakening.",
  //   keywords:
  //     "Forces of the Sun, Solar Consciousness, Solar Pulse, Theurgy, Archetypal Astrology, Emerging Spirit, Quantum Entanglement, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=26",
  // },
  // 27: {
  //   title:
  //     "Forces of the Moon: Lunar Mysteries & The Unconscious Realm | School of Our Divine Infinite Being",
  //   description:
  //     "Unveil the Lunar Mysteries and the occult Forces of the Moon. Journey into the Unconscious Realms and learn to harness lunar energy for psychic phenomena, divination, and introspection at our school.",
  //   keywords:
  //     "Forces of the Moon, Lunar Mysteries, Unconscious Realm, Psychic Phenomena, High Priestess, Theurgy, Archetypal Self, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=27",
  // },
  // 28: {
  //   title:
  //     "Forces of Mercury: Alchemy of the Enlightened Mind | School of Our Divine Infinite Being",
  //   description:
  //     "Unveil the Forces of Mercury and the alchemy of the enlightened mind. Explore Mercury's role as the messenger of the gods, its connection to The Magician Tarot, and its influence on communication, intellect, and logic.",
  //   keywords:
  //     "Forces of Mercury, Mercury's Alchemy, Hermes, The Magician Tarot, Communication, Intellect, Logic, Trickster Archetype, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=28",
  // },
  // 29: {
  //   title:
  //     "Forces of Venus: Nurturing Attraction & Beauty | School of Our Divine Infinite Being",
  //   description:
  //     "Unveil the Forces of Venus, exploring the nurturing energies of attraction, beauty, and love. Discover the archetypes of the Influx of Beauty and the Devouring Mother, and Venus's link to The Empress Tarot.",
  //   keywords:
  //     "Forces of Venus, Attraction, Beauty, Love, The Empress Tarot, Devouring Mother, Influx of Beauty, Divine Feminine, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=29",
  // },
  // 30: {
  //   title:
  //     "Forces of Mars: The Martial Symphony of Focused Will | School of Our Divine Infinite Being",
  //   description:
  //     "Unravel the Forces of Mars and its martial symphony. Explore the archetypes of focused will, the drive to master, and the 'Flow State' as taught through the lens of The Chariot Tarot at our school.",
  //   keywords:
  //     "Forces of Mars, Martial Symphony, Focused Will, The Chariot Tarot, Flow State, Drive to Master, Conquest, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=30",
  // },
  // 31: {
  //   title:
  //     "Forces of Jupiter: Expansion, Fortune & Connection | School of Our Divine Infinite Being",
  //   description:
  //     "Navigate Jupiter's Cosmic Symphony and the forces of expansion, fortune, and connection. Explore Jupiter's role as the King of Gods and its link to the Wheel of Fortune Tarot in our school's teachings.",
  //   keywords:
  //     "Forces of Jupiter, Expansion, Fortune, Connection, Cosmic Symphony, King of Gods, Wheel of Fortune Tarot, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=31",
  // },
  // 32: {
  //   title:
  //     "Forces of Saturn: Time, Karma & Total Completion | School of Our Divine Infinite Being",
  //   description:
  //     "Navigate the Forces of Saturn, the great taskmaster of time, karma, and discipline. Explore the archetypes of the Perfecting Force and the Wisdom of Limitations, and Saturn's link to The World Tarot.",
  //   keywords:
  //     "Forces of Saturn, Time, Karma, Discipline, Limitations, Total Completion, The World Tarot, Wisdom of Limitations, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=32",
  // },
  // 33: {
  //   title:
  //     "Archetype of Aries: The Warrior King's Cosmic Fury | School of Our Divine Infinite Being",
  //   description:
  //     "Unleash the Archetype of Aries, the Warrior King. Explore the cosmic fury and wisdom of this cardinal fire sign, its connection to The Emperor Tarot, and its role as a primal force of initiation.",
  //   keywords:
  //     "Archetype of Aries, Warrior King, Cosmic Fury, Cardinal Fire, The Emperor Tarot, Primal Force, Initiation, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=33",
  // },
  // 34: {
  //   title:
  //     "Archetype of Taurus: Strength, Stability & The Hierophant | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the Archetype of Taurus, the embodiment of strength, stability, and staying power. Discover the lessons of this Fixed Earth sign and its connection to The Hierophant Tarot in our school's teachings.",
  //   keywords:
  //     "Archetype of Taurus, The Hierophant Tarot, Fixed Earth, Strength, Stability, Staying Power, The Bull, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=34",
  // },
  // 35: {
  //   title:
  //     "Archetype of Gemini: Syncretism & The Lovers | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the Archetype of Gemini and its dance of syncretism and duality. Discover the connection between this Mutable Air sign and The Lovers Tarot, embodying reflective consideration and cosmic analysis.",
  //   keywords:
  //     "Archetype of Gemini, The Lovers Tarot, Syncretism, Duality, Mutable Air, Cosmic Analysis, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=35",
  // },
  // 36: {
  //   title:
  //     "Archetype of Cancer: The Cosmic Sea & The Chariot | School of Our Divine Infinite Being",
  //   description:
  //     "Navigate the cosmic sea of meaning with the Archetype of Cancer. Explore the depths of this Cardinal Water sign, its connection to the Anima Mundi, and its powerful representation in The Chariot Tarot.",
  //   keywords:
  //     "Archetype of Cancer, The Chariot Tarot, Cardinal Water, Anima Mundi, Cosmic Sea, Emotional Intelligence, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=36",
  // },
  // 37: {
  //   title:
  //     "Archetype of Leo: Fixed Fire, Strength & Lust | School of Our Divine Infinite Being",
  //   description:
  //     "Embrace the radiance of the Archetype of Leo. Explore the nature of this Fixed Fire sign, its royal confidence, and its potent connection to both the Strength and Lust Tarot cards in our school's teachings.",
  //   keywords:
  //     "Archetype of Leo, Fixed Fire, Strength Tarot, Lust Tarot, Whore of Babalon, Royal Confidence, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=37",
  // },
  // 38: {
  //   title:
  //     "Archetype of Virgo: The Virgin Journey & The Hermit | School of Our Divine Infinite Being",
  //   description:
  //     "Embark on the Virgin Journey of Introspection with the Archetype of Virgo. Discover the wisdom of this Mutable Earth sign and its profound connection to The Hermit Tarot and the Lantern of Knowledge.",
  //   keywords:
  //     "Archetype of Virgo, The Hermit Tarot, Introspection, Wisdom, Mutable Earth, Hecate, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=38",
  // },
  // 39: {
  //   title:
  //     "Archetype of Libra: Balancing the Cosmic Scales & Divine Justice | School of Our Divine Infinite Being",
  //   description:
  //     "Explore the harmonious dance of the Archetype of Libra. Discover the principles of balance, fairness, and divine order, and Libra's connection to the Justice and Adjustment Tarot cards at our school.",
  //   keywords:
  //     "Archetype of Libra, Justice Tarot, Adjustment Tarot, Cosmic Scales, Balance, Harmony, Cardinal Air, Lady Justice, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=39",
  // },
  // 40: {
  //   title:
  //     "Archetype of Scorpio: Transformation, Rebirth & The Death Tarot | School of Our Divine Infinite Being",
  //   description:
  //     "Navigate the transformative waters of the Archetype of Scorpio. Explore the profound themes of death, rebirth, and emotional alchemy, and Scorpio's connection to the powerful Death Tarot card.",
  //   keywords:
  //     "Archetype of Scorpio, Death Tarot, Transformation, Rebirth, Fixed Water, Alchemy of Emotions, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=40",
  // },
  // 41: {
  //   title:
  //     "Archetype of Sagittarius: Alchemy, Art & Transformation | School of Our Divine Infinite Being",
  //   description:
  //     "Embark on an alchemical journey with the Archetype of Sagittarius. Explore the transformative power of this Mutable Fire sign and its profound connection to the Art (Temperance) Tarot card.",
  //   keywords:
  //     "Archetype of Sagittarius, Art Tarot, Temperance Tarot, Alchemy, Mutable Fire, Transformation, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=41",
  // },
  // 42: {
  //   title:
  //     "Archetype of Capricorn: The Erotic Impulse & The Devil Tarot | School of Our Divine Infinite Being",
  //   description:
  //     "Embrace the fearlessness of the Archetype of Capricorn. Explore the earthly symphony of this Cardinal Earth sign, its connection to Pan and Prometheus, and the profound wisdom of The Devil Tarot card.",
  //   keywords:
  //     "Archetype of Capricorn, The Devil Tarot, Cardinal Earth, Pan, Prometheus, Erotic Impulse, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=42",
  // },
  // 43: {
  //   title:
  //     "Archetype of Aquarius: Genius, Individualism & The Star Tarot | School of Our Divine Infinite Being",
  //   description:
  //     "Delve into the Archetype of Aquarius, the embodiment of genius, individualism, and humanitarianism. Explore the boundless nature of this Fixed Air sign and its connection to The Star Tarot card.",
  //   keywords:
  //     "Archetype of Aquarius, The Star Tarot, Fixed Air, Genius, Individualism, Humanitarianism, Collective Consciousness, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=43",
  // },
  // 44: {
  //   title:
  //     "Archetype of Pisces: Navigating the Cosmic Depths & The Moon Tarot | School of Our Divine Infinite Being",
  //   description:
  //     "Navigate the cosmic depths with the Archetype of Pisces. Explore the emotional maturity and introspective wisdom of this Mutable Water sign, and its deep connection to The Moon Tarot card.",
  //   keywords:
  //     "Archetype of Pisces, The Moon Tarot, Mutable Water, Cosmic Depths, Introspection, Emotional Maturity, Theurgy, Divine Infinite Being",
  //   ogImage:
  //     "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp",
  //   url: "https://www.divineinfinitebeing.com/layman-explanation?section=44",
  // },
};

export default function Index() {
  const router = useRouter();
  const { section } = router.query;

  // Find the correct metadata object, or use the default one
  const meta = chaptersMetaData[section] || chaptersMetaData.default;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);

  const [allComponentViewerState, setAllComponentViewerState] = useState(false);


  const [anchorEl, setAnchorEl] = React.useState(null);
  const openbtn = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosebtn = (index) => {
    console.log("index in close+++", index);
    if (!isNaN(index)) {
      setAllComponentViewerState(false);
      Router.push({
        pathname: "/layman-explanation",
        query: { section: index },
      });
    }
    setAnchorEl(null);
  };
  const menuItems = [
    { id: 0, name: "Introduction" },
    { id: 1, name: "(I) Rota, The Wheel Of Astrological Tarot" },
    { id: 2, name: "(II) The Orphic Egg" },
    { id: 3, name: "(III) The Transpersonal Egg" },
    { id: 4, name: "(IV ) The Pentagram" },
    { id: 5, name: "(V) Yin And Yang A Universal Dance Of Opposites And Harmony" },
    {
      id: 6,
      name: "(VI) String Theory",
    },
    { id: 7, name: "(VII) Om" },
    // { id: 8, name: "(VIII) YHVH-Elohim" },
    { id: 8, name: "(VIII) The Sacred Divine Names of Invocation" },
    // { id: 9, name: "(IX) Helios" },
    { id: 9, name: "(IX) The Demiurgos: Architect of Worlds and the Boundary of Becoming" },
    // { id: 10, name: "(X) Protogonos (Phanes)" },
    { id: 10, name: "(X) Rādhā–Kṛṣṇa infinite play and eternal surrender" },
    // { id: 11, name: "(XI) The Demiurgos Architect Of Worlds And The Boundary Of Becoming" },
    { id: 11, name: "(XI) Kālī: The Fertility of the Void, Mother of the Mystery" },
    // { id: 12, name: "(XII) Kali-Krishna" },
    { id: 12, name: "(XII) Hekátē–Kālī: Threshold and Purge at the Daemonic Crossing" },
    { id: 13, name: "(XII) Śiva–Śakti — The Living Pulse of the Infinite" },
    // { id: 14, name: "(XIV) Shakti" },
    { id: 14, name: "(XIV) Krishna: The Ontic Supreme Persona and the Infinite Father in Play" },
    // { id: 15, name: "(XV) Krishna" },
    { id: 15, name: "(XV) Hermes: Lord of Divination and Overseer of the Rites" },
    // { id: 16, name: "(XVI) Kali" },
    { id: 16, name: "(XVI) Aion — Future as the Return, and the Zodiacal Gate from Chronos to Aion" },
    { id: 17, name: "(XVII) El Shaddai" },
    // { id: 17, name: "(XVII) Hermes" },
    { id: 18, name: "(XVIII) Veneration of the Full Moon" },
    // { id: 18, name: "(XVIII) Hecate" },
    { id: 19, name: "(XIX) Veneration of the New Moon" },
    // { id: 19, name: "(XIX) Radha Krishna The Sacred Innocence Of Divine Surrender" },
    { id: 20, name: "(XX) The Zodiac and the Planetary Powers" },
    // { id: 20, name: "(XX) El Shaddai" },
    // { id: 21, name: "(XXI) Ehyeh ('Ehye 'ăšer 'Ehye)" },
    // { id: 22, name: "(XXII) YHVH (Yod-Heh-Vav-Heh)" },
    // { id: 23, name: "(XXIII) Elohim" },
    // { id: 24, name: "(XXIV) Veneration Of The Full Moon" },
    // { id: 25, name: "(XXV) Veneration Of The New Moon" },
    // { id: 26, name: "(XXVI) Forces Of The Sun" },
    // { id: 27, name: "(XXVII) Forces Of The Moon" },
    // { id: 28, name: "(XXVIII) Forces Of Mercury" },
    // { id: 29, name: "(XXIX) Forces Of Venus" },
    // { id: 30, name: "(XXX) Forces Of Mars" },
    // { id: 31, name: "(XXXI) Forces Of Jupiter" },
    // { id: 32, name: "(XXXII) Forces Of Saturn" },
    // { id: 33, name: "(XXXIII) Archetype Of Aries" },
    // { id: 34, name: "(XXXIV) Archetype Of Taurus" },
    // { id: 35, name: "(XXXV) Archetype Of Gemini" },
    // { id: 36, name: "(XXXVI) Archetype Of Cancer" },
    // { id: 37, name: "(XXXVII) Archetype Of Leo" },
    // { id: 38, name: "(XXXVIII) Archetype Of Virgo" },
    // { id: 39, name: "(XXXIX) Archetype Of Libra" },
    // { id: 40, name: "(XL) Archetype Of Scorpio" },
    // { id: 41, name: "(XLI) Archetype Of Sagittarius" },
    // { id: 42, name: "(XLII) Archetype Of Capricorn" },
    // { id: 43, name: "(XLIII) Archetype Of Aquarius" },
    // { id: 44, name: "(XLIV) Archetype Of Pisces" },
  ];

  const AllComponentViewer = () => {
    setAllComponentViewerState(!allComponentViewerState);
  };

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }

  return (
    <>
      {/* <Head>
        <title>
          School Layman Explanation | School of Our Divine Infinite Being
        </title>
        <meta name="robots" content="index, follow"></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Theurgy, Polytheistic Monism, Oracle, Symbolic Archetypes, Theurgy, Divine Infinite Being, Self Realization"
        ></meta>
        <meta
          name="description"
          content="Explore the Layman Explanation at the School of Our Divine Infinite Being. Delve into our unique blend of polytheism and monism through our detailed symbolic Archetypes and Theurgic practices."
        ></meta>
        <meta
          name="author"
          content="School of Our Divine Infinite Being"
        ></meta>
        <meta
          name="subject"
          content="Theurgic Education and Spiritual Enlightenment"
        ></meta>

        <meta name="language" content="English"></meta>
        <meta name="geo.region" content="US"></meta>
        <meta
          name="geo.placename"
          content="Location of Your Institution"
        ></meta>

        <meta
          property="og:title"
          content="School Layman Explanation | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="Layman Explanation"></meta>
        <meta
          property="og:description"
          content="Explore the Layman Explanation at the School of Our Divine Infinite Being. Delve into our unique blend of polytheism and monism through our detailed symbolic Archetypes and Theurgic practices."
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/layamn_explanation_og_img.webp"
        ></meta>
        <meta
          property="twitter:title"
          content="School Layman Explanation | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/layman-explanation"
        ></meta>
        <meta
          property="twitter:description"
          content="Explore the Layman Explanation at the School of Our Divine Infinite Being. Delve into our unique blend of polytheism and monism through our detailed symbolic Archetypes and Theurgic practices."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/layman-explanation"
        ></meta>

        <link
          rel="canonical"
          href="https://www.divineinfinitebeing.com/layman-explanation"
        />

        <link
          rel="preload"
          href="/image/layman-explanation-new/layman_bnnr_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/layman-explanation-new/layman_bnnr_bg_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/layman-explanation-new/bnnr_responsv_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/logobanner_cropped.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />

        <style>
          {`
          .laymanmain_ochema_ritual_blockone__Z8zMW {
          background: url(/image/layman-explanation-new/layman_bnnr_img.webp), url(/image/layman-explanation-new/layman_bnnr_bg_img.webp);
          background-repeat: no-repeat;
          background-size: 450px, 100% 100%;
          background-position: bottom 17px right 193px, right top;
          border-radius: 0;
          padding: 0 0 26px;
          margin-bottom: 0;
          min-height: 1px;
          border-top: 1px solid #000;
      }
      @media screen and (max-width: 1680px) {
        .laymanmain_ochema_ritual_blockone__Z8zMW {
            background-size: 425px, 100% 100%;
            background-position: bottom 17px right 135px, right top;
        }
      }
        @media screen and (max-width: 1530px) {
    .laymanmain_ochema_ritual_blockone__Z8zMW {
       
        background-position: bottom 17px right 104px, right top;
    }
}
    @media screen and (max-width: 1380px) {
    
    .laymanmain_ochema_ritual_blockone__Z8zMW {
        background-size: 365px, 100% 100%;
        background-position: bottom 24px right 105px, right top;
    }
        @media screen and (max-width: 1199px) {
  
    .laymanmain_ochema_ritual_blockone__Z8zMW {
      background: url(/image/layman-explanation-new/bnnr_responsv_img.webp);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      margin-top: -20px;
      padding-bottom: 2%;
    }
          }
    @media screen and (max-width: 499px) {
    .laymanmain_ochema_ritual_blockone__Z8zMW {
      padding-bottom: 4%;
    }
          }
`}
        </style>
      </Head> */}

      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <link rel="canonical" href={meta.url} />

        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={meta.url} />
        <meta property="og:image" content={meta.ogImage} />
        <meta property="og:image:alt" content={meta.title} />

        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:url" content={meta.url} />
        <meta property="twitter:image" content={meta.ogImage} />
        <meta property="twitter:image:alt" content={meta.title} />

        {/* Other static tags */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />

        <link
          rel="canonical"
          href="https://www.divineinfinitebeing.com/layman-explanation"
        />

        <link
          rel="preload"
          href="/image/layman-explanation-new/layman_bnnr_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/layman-explanation-new/layman_bnnr_bg_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/layman-explanation-new/bnnr_responsv_img.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          href="/image/logobanner_cropped.webp"
          as="image"
          type="image/webp"
          fetchpriority="high"
        />

        <style>
          {`
          .laymanmain_ochema_ritual_blockone__Z8zMW {
          background: url(/image/layman-explanation-new/layman_bnnr_img.webp), url(/image/layman-explanation-new/layman_bnnr_bg_img.webp);
          background-repeat: no-repeat;
          background-size: 450px, 100% 100%;
          background-position: bottom 17px right 193px, right top;
          border-radius: 0;
          padding: 0 0 26px;
          margin-bottom: 0;
          min-height: 1px;
          border-top: 1px solid #000;
      }
      @media screen and (max-width: 1680px) {
        .laymanmain_ochema_ritual_blockone__Z8zMW {
            background-size: 425px, 100% 100%;
            background-position: bottom 17px right 135px, right top;
        }
      }
        @media screen and (max-width: 1530px) {
    .laymanmain_ochema_ritual_blockone__Z8zMW {
       
        background-position: bottom 17px right 104px, right top;
    }
}
    @media screen and (max-width: 1380px) {
    
    .laymanmain_ochema_ritual_blockone__Z8zMW {
        background-size: 365px, 100% 100%;
        background-position: bottom 24px right 105px, right top;
    }
        @media screen and (max-width: 1199px) {
  
    .laymanmain_ochema_ritual_blockone__Z8zMW {
      background: url(/image/layman-explanation-new/bnnr_responsv_img.webp);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      margin-top: -20px;
      padding-bottom: 2%;
    }
          }
    @media screen and (max-width: 499px) {
    .laymanmain_ochema_ritual_blockone__Z8zMW {
      padding-bottom: 4%;
    }
          }
`}
        </style>
      </Head>

      <div className={styles.layman_bnnr_main_wrpr}>
        <div className={styles.ochema_ritual_blockone}>
          <div className={styles.ochema_ritual_banner_main_wrpr}>
            <div className={styles.bannerMenu_btn}>
              <Button
                id="basic-button"
                aria-controls={openbtn ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openbtn ? "true" : undefined}
                onClick={handleClick}
              >
                LIST OF PAGES
                <KeyboardArrowDownIcon className={styles.bannerMenu_icon} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openbtn}
                onClose={handleClosebtn}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                className="central_doctrine_yellowNav_menu"
              >
                {menuItems?.map((data, index) => (
                  <MenuItem onClick={() => handleClosebtn(index)} key={index}>
                    {data.name}
                  </MenuItem>
                ))}
              </Menu>
              <Button
                onClick={() => AllComponentViewer()}
                className={styles.bannerscroll_btn}
              >
                Read as a single scroll
              </Button>
            </div>
            <div className={styles.ochema_ritual_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <Image
                    src="/image/viewicon.webp"
                    alt="View Icon"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "auto" }}
                    priority={true}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </span>
                <Image
                  src="/image/logobanner_cropped.webp"
                  alt="School of Our Divine Infinite Being Logo"
                  width={332}
                  height={332}
                  style={{ width: "100%", height: "auto" }}
                  priority={true}
                  placeholder="blur"
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.ochema_ritual_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
              <h3>SCHOOL LAYMAN EXPLANATION</h3>
            </div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>
      {/*  =============================================== Body Start ===================================== */}

      {/* ============================ MAIN BODY ================================ */}

      <LymanMainComps allComponentViewerState={allComponentViewerState} />

      {showOtherBlocks && (
        <>
          {/* ===================== Chapters end=============== */}

          {/* ==================== modal =================== */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>

                  <Image
                    src={logoBanner}
                    alt="bannerLogo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    priority={false}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}
